module.exports = __webpack_public_path__ + "img/paypal.f3e24db2.svg";